import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { maxAreaChange, minAreaChange } from '../../actions';
import { getMaxArea, getMinArea } from '../../selectors';
import { TThunkDispatch } from '../../types/redux/thunk';
import { setQueryParameter } from '../../utils';
import { InputNumberRange } from '../InputNumberRange';

export function AreaInput() {
  const dispatch: TThunkDispatch = useDispatch();
  const minArea = useSelector(getMinArea);
  const maxArea = useSelector(getMaxArea);

  const handleAreaChange = React.useCallback(
    (type: 'min' | 'max') => (e: React.SyntheticEvent, value: string) => {
      const map = {
        min: { handler: minAreaChange, key: 'minArea' },
        max: { handler: maxAreaChange, key: 'maxArea' },
      };

      dispatch(map[type].handler(Number(value) || null));
      setQueryParameter(map[type].key, value);
    },
    [dispatch],
  );

  return (
    <InputNumberRange
      testId="AreaInput"
      onChange={handleAreaChange}
      min={minArea}
      max={maxArea}
      rightAdornment="м²"
      title="Площадь"
    />
  );
}
